import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Home.css";
import whatsapp from "../images/whatsapp.png";
import slide1 from "../images/bg1.jpg";
import slide2 from "../images/bg2.jpg";
import slide3 from "../images/bg3.jpg";

import {
  Zap, Truck, Building, Car,
  Landmark, GraduationCap, Train,
  Stethoscope, Hotel
} from "lucide-react";

const Home = () => {
  const [slide, setSlide] = useState(0);
  const [lang, setLang] = useState("en");

  // Load language from localStorage
  useEffect(() => {
    const savedLang = localStorage.getItem("lang");
    if (savedLang && ["en", "hi", "mr"].includes(savedLang)) {
      setLang(savedLang);
    }
  }, []);

  // Save language
  useEffect(() => {
    localStorage.setItem("lang", lang);
  }, [lang]);

  // Auto slide
  useEffect(() => {
    const id = setInterval(() => setSlide((s) => (s + 1) % 3), 5000);
    return () => clearInterval(id);
  }, []);

  // ALL TEXT IN ONE PLACE
  const text = {
    en: {
      heroTitle: ["We Are An Internationally Acknowledged", "ISO Certification Body And An Exemplar", "Global Recognized Training Partner"],
      heroSubtitle: "Spread Across Over 30 Countries.",
      heroBtn: "More About",

      whyTitle: "Reason For Choosing Us",
      whyDesc: "To provide business planning and marketing services our being able to do what we like best.",
      industryKnowledge: "Industry Knowledge",
      qualifiedAuditors: "Qualified Auditors",
      industryKnowledgeDesc: "Deep expertise across various fields and standards",
      qualifiedAuditorsDesc: "Professional, experienced, and dedicated to precision.",
      yearsExp: "Years of Experience",
      expList: ["Financial Services", "Business Services", "Consumer Products", "Marketing Management"],

      industriesTitle: "Industries We Served",
      industries: [
        "Electrical & Electronics",
        "Transport & Logistics",
        "Construction Industry",
        "Automotive Industry",
        "Public Sector",
        "Education Industry",
        "ISO for Railways",
        "Medical Devices",
        "Hotel & Leisure Service",
      ],

      consulting: [
        { title: "Best consulting", desc: "Our consulting firm drives sustainable growth and lasting impact through expert insights and innovative strategies" },
        { title: "Happy clients", desc: "We’re committed to building lasting relationships and achieving results that leave our clients truly satisfied." },
        { title: "Experienced team", desc: "Our skilled team brings extensive expertise and a strong record of success to each project, delivering high-quality results" },
      ],
      readMore: "READ MORE",

      standardsTitle: "Standards We Certify",
      standardsText: "<strong>Global Certification</strong> is among the best and most reliable ISO certification bodies. The certification body was established with the objective of providing certification services to management systems.",
      standardsList: "<strong>Global Certification</strong> provides ISO certification services for ISO 9001, ISO 14001, ISO 22301, ISO 21001, ISO 37001, ISO 41001, ISO 45001, ISO 50001, ISO 13485, ISO 22000, HACCP, ISO 27001, IATF 16949, CE, ROHS, KOSHER, and Product certifications.",
      auditorsText: "Our auditors have the knowledge and expertise to audit and maintain ISO compliance with your organization’s management system.",
      moreAboutCompany: "MORE ABOUT COMPANY",
      trustedClients: "Trusted by 500+ Clients",
      satisfaction: "100% Satisfaction Guaranteed",
      downloadCatalogue: "Download Catalogue",

      ourMission: "Our Mission",
      missionText: "To empower organizations worldwide with globally recognized ISO certifications, delivering customized, sustainable, and excellence-driven solutions that foster long-term growth and operational success.",
      ourVision: "Our Vision",
      visionText: "To be the most trusted global leader in ISO certification, recognized for uncompromising integrity, innovation, and client-centric approach in building a quality-driven future.",

      contactUs: "CONTACT US",
      globalCert: "Global Certification",
      address: "15A, Navjivan Colony, Wardha Road, Narendra Nagar, Nagpur-440015",
      phoneEmail: "Phone: +91 9975977462 &nbsp;&nbsp; Email: info@globalcertification.com",
      appointment: "APPOINTMENT",

      aboutCompany: "About Company",
      usefulLinks: "Useful Links",
      othersLinks: "Other Links",
      footerLinks: [
        { name: "Location", path: "/contact-us" },
        { name: "Contact Us", path: "/contact-us" },
        { name: "Gallery", path: "/gallery" },
        { name: "Services", path: "/services-iso-standards" },
      ],
      copyright: `© ${new Date().getFullYear()} Global Certification. All Rights Reserved.`,
    },

    hi: {
      heroTitle: ["हम अंतरराष्ट्रीय स्तर पर मान्यता प्राप्त", "आईएसओ प्रमाणन निकाय हैं और एक आदर्श", "वैश्विक मान्यता प्राप्त प्रशिक्षण भागीदार"],
      heroSubtitle: "30 से अधिक देशों में फैले हुए।",
      heroBtn: "और जानें",

      whyTitle: "हमें चुनने का कारण",
      whyDesc: "व्यावसायिक योजना और विपणन सेवाएँ प्रदान करने के लिए, जो हमें सबसे अच्छा करना पसंद है।",
      industryKnowledge: "उद्योग ज्ञान",
      qualifiedAuditors: "योग्य ऑडिटर",
      industryKnowledgeDesc: "विभिन्न क्षेत्रों और मानकों में गहन विशेषज्ञता",
      qualifiedAuditorsDesc: "पेशेवर, अनुभवी, और सटीकता के प्रति समर्पित।",
      yearsExp: "वर्षों का अनुभव",
      expList: ["वित्तीय सेवाएँ", "व्यावसायिक सेवाएँ", "उपभोक्ता उत्पाद", "विपणन प्रबंधन"],

      industriesTitle: "हम जिन उद्योगों की सेवा करते हैं",
      industries: [
        "विद्युत और इलेक्ट्रॉनिक्स",
        "परिवहन और लॉजिस्टिक्स",
        "निर्माण उद्योग",
        "ऑटोमोटिव उद्योग",
        "सार्वजनिक क्षेत्र",
        "शिक्षा उद्योग",
        "रेलवे के लिए ISO",
        "चिकित्सा उपकरण",
        "होटल और अवकाश सेवा",
      ],

      consulting: [
        { title: "सर्वश्रेष्ठ परामर्श", desc: "हमारी परामर्श फर्म विशेषज्ञ अंतर्दृष्टि और नवीन रणनीतियों के माध्यम से स्थायी विकास और दीर्घकालिक प्रभाव प्रदान करती है।" },
        { title: "खुश ग्राहक", desc: "हम दीर्घकालिक संबंध बनाने और परिणाम देने के लिए प्रतिबद्ध हैं जो हमारे ग्राहकों को वास्तव में संतुष्ट करते हैं।" },
        { title: "अनुभवी टीम", desc: "हमारी कुशल टीम प्रत्येक प्रोजेक्ट में व्यापक विशेषज्ञता और सफलता का मजबूत रिकॉर्ड लाती है।" },
      ],
      readMore: "और पढ़ें",

      standardsTitle: "हम जिन मानकों का प्रमाणन करते हैं",
      standardsText: "<strong>ग्लोबल सर्टिफिकेशन</strong> सर्वश्रेष्ठ और सबसे विश्वसनीय ISO प्रमाणन निकायों में से एक है। यह प्रमाणन निकाय प्रबंधन प्रणालियों को प्रमाणन सेवाएँ प्रदान करने के उद्देश्य से स्थापित किया गया था।",
      standardsList: "<strong>ग्लोबल सर्टिफिकेशन</strong> ISO 9001, ISO 14001, ISO 22301, ISO 21001, ISO 37001, ISO 41001, ISO 45001, ISO 50001, ISO 13485, ISO 22000, HACCP, ISO 27001, IATF 16949, CE, ROHS, KOSHER, और उत्पाद प्रमाणन के लिए ISO प्रमाणन सेवाएँ प्रदान करता है।",
      auditorsText: "हमारे ऑडिटरों के पास आपकी संगठन की प्रबंधन प्रणाली के साथ ISO अनुपालन का ऑडिट और रखरखाव करने का ज्ञान और विशेषज्ञता है।",
      moreAboutCompany: "कंपनी के बारे में और जानें",
      trustedClients: "500+ ग्राहकों द्वारा विश्वसनीय",
      satisfaction: "100% संतुष्टि की गारंटी",
      downloadCatalogue: "कैटलॉग डाउनलोड करें",

      ourMission: "हमारा मिशन",
      missionText: "वैश्विक स्तर पर मान्यता प्राप्त ISO प्रमाणन के साथ दुनिया भर के संगठनों को सशक्त बनाना, अनुकूलित, टिकाऊ और उत्कृष्टता-प्रेरित समाधान प्रदान करना जो दीर्घकालिक विकास और परिचालन सफलता को बढ़ावा देते हैं।",
      ourVision: "हमारा विजन",
      visionText: "ISO प्रमाणन में सबसे विश्वसनीय वैश्विक नेता बनना, गुणवत्ता-प्रेरित भविष्य के निर्माण में अटूट सत्यनिष्ठा, नवाचार और ग्राहक-केंद्रित दृष्टिकोण के लिए मान्यता प्राप्त।",

      contactUs: "हमसे संपर्क करें",
      globalCert: "ग्लोबल सर्टिफिकेशन",
      address: "15A, नवजीवन कॉलोनी, वर्धा रोड, नरेंद्र नगर, नागपुर-440015",
      phoneEmail: "फोन: +91 9975977462 &nbsp;&nbsp; ईमेल: info@globalcertification.com",
      appointment: "अपॉइंटमेंट",

      aboutCompany: "कंपनी के बारे में",
      usefulLinks: "उपयोगी लिंक",
      othersLinks: "अन्य लिंक",
      footerLinks: [
        { name: "स्थान", path: "/contact-us" },
        { name: "हमसे संपर्क करें", path: "/contact-us" },
        { name: "गैलरी", path: "/gallery" },
        { name: "सेवाएँ", path: "/services-iso-standards" },
      ],
      copyright: `© ${new Date().getFullYear()} ग्लोबल सर्टिफिकेशन। सभी अधिकार सुरक्षित।`,
    },

    mr: {
      heroTitle: ["आम्ही आंतरराष्ट्रीय स्तरावर मान्यताप्राप्त", "आयएसओ प्रमाणन संस्था आहोत आणि एक आदर्श", "जागतिक स्तरावर मान्यताप्राप्त प्रशिक्षण भागीदार"],
      heroSubtitle: "30 पेक्षा जास्त देशांमध्ये पसरलेले।",
      heroBtn: "अधिक जाणा",

      whyTitle: "आम्हाला निवडण्याचे कारण",
      whyDesc: "व्यवसाय नियोजन आणि विपणन सेवा प्रदान करण्यासाठी, जे आम्हाला सर्वोत्तम करायला आवडते.",
      industryKnowledge: "उद्योग ज्ञान",
      qualifiedAuditors: "पात्र ऑडिटर",
      industryKnowledgeDesc: "विविध क्षेत्रे आणि मानकांमध्ये सखोल कौशल्य",
      qualifiedAuditorsDesc: "व्यावसायिक, अनुभवी आणि अचूकतेसाठी समर्पित.",
      yearsExp: "वर्षांचा अनुभव",
      expList: ["आर्थिक सेवा", "व्यावसायिक सेवा", "ग्राहक उत्पादने", "विपणन व्यवस्थापन"],

      industriesTitle: "आम्ही ज्या उद्योगांची सेवा करतो",
      industries: [
        "विद्युत आणि इलेक्ट्रॉनिक्स",
        "वाहतूक आणि लॉजिस्टिक्स",
        "बांधकाम उद्योग",
        "ऑटोमोटिव्ह उद्योग",
        "सार्वजनिक क्षेत्र",
        "शिक्षण उद्योग",
        "रेल्वेसाठी ISO",
        "वैद्यकीय उपकरणे",
        "हॉटेल आणि मनोरंजन सेवा",
      ],

      consulting: [
        { title: "सर्वोत्तम सल्लागार", desc: "आमची सल्लागार फर्म तज्ज्ञ अंतर्दृष्टी आणि नाविन्यपूर्ण धोरणांद्वारे शाश्वत वाढ आणि दीर्घकालीन प्रभाव प्रदान करते." },
        { title: "समाधानी ग्राहक", desc: "आम्ही दीर्घकालीन संबंध निर्माण आणि ग्राहकांना खरोखर समाधानी ठेवणारे परिणाम देण्यासाठी वचनबद्ध आहोत." },
        { title: "अनुभवी टीम", desc: "आमची कुशल टीम प्रत्येक प्रकल्पात व्यापक कौशल्य आणि यशस्वी रेकॉर्ड आणते." },
      ],
      readMore: "अधिक वाचा",

      standardsTitle: "आम्ही ज्या मानकांचे प्रमाणन करतो",
      standardsText: "<strong>ग्लोबल सर्टिफिकेशन</strong> सर्वोत्तम आणि विश्वासार्ह ISO प्रमाणन संस्थांपैकी एक आहे. प्रबंधन प्रणालींना प्रमाणन सेवा देण्याच्या उद्देशाने ही संस्था स्थापन करण्यात आली होती.",
      standardsList: "<strong>ग्लोबल सर्टिफिकेशन</strong> ISO 9001, ISO 14001, ISO 22301, ISO 21001, ISO 37001, ISO 41001, ISO 45001, ISO 50001, ISO 13485, ISO 22000, HACCP, ISO 27001, IATF 16949, CE, ROHS, KOSHER, आणि उत्पादन प्रमाणनांसाठी ISO प्रमाणन सेवा प्रदान करते.",
      auditorsText: "आमच्या ऑडिटर्सकडे तुमच्या संस्थेच्या प्रबंधन प्रणालीसह ISO अनुपालन ऑडिट आणि देखभाल करण्याचे ज्ञान आणि कौशल्य आहे.",
      moreAboutCompany: "कंपनीबद्दल अधिक",
      trustedClients: "500+ ग्राहकांनी विश्वास ठेवला",
      satisfaction: "100% समाधानाची हमी",
      downloadCatalogue: "कॅटलॉग डाउनलोड करा",

      ourMission: "आमचे ध्येय",
      missionText: "जागतिक स्तरावर मान्यताप्राप्त ISO प्रमाणनांसह जगभरातील संस्थांना सक्षम करणे, सानुकूलित, शाश्वत आणि उत्कृष्टता-प्रेरित उपाय प्रदान करणे जे दीर्घकालीन वाढ आणि परिचालन यशाला चालना देतात.",
      ourVision: "आमची दृष्टी",
      visionText: "ISO प्रमाणनात सर्वात विश्वासार्ह जागतिक नेते बनणे, गुणवत्ता-प्रेरित भविष्यासाठी अटूट सचोटी, नाविन्य आणि ग्राहक-केंद्रित दृष्टिकोणासाठी ओळखले जाणे.",

      contactUs: "आमच्याशी संपर्क साधा",
      globalCert: "ग्लोबल सर्टिफिकेशन",
      address: "15A, नवजीवन कॉलोनी, वर्धा रोड, नरेंद्र नगर, नागपूर-440015",
      phoneEmail: "फोन: +91 9975977462 &nbsp;&nbsp; ईमेल: info@globalcertification.com",
      appointment: "भेट",

      aboutCompany: "कंपनीबद्दल",
      usefulLinks: "उपयोगी लिंक्स",
      othersLinks: "इतर लिंक्स",
      footerLinks: [
        { name: "स्थान", path: "/contact-us" },
        { name: "आमच्याशी संपर्क", path: "/contact-us" },
        { name: "गॅलरी", path: "/gallery" },
        { name: "सेवा", path: "/services-iso-standards" },
      ],
      copyright: `© ${new Date().getFullYear()} ग्लोबल सर्टिफिकेशन। सर्व हक्क राखीव।`,
    },
  };

  // Safe fallback
  const t = text[lang] || text.en;

  return (
    <div className="home-container">
      {/* LANGUAGE SWITCHER */}
      {/* <div className="lang-switcher">
        <button onClick={() => setLang("en")} className={lang === "en" ? "active" : ""}>English</button>
        <button onClick={() => setLang("hi")} className={lang === "hi" ? "active" : ""}>हिंदी</button>
        <button onClick={() => setLang("mr")} className={lang === "mr" ? "active" : ""}>मराठी</button>
      </div> */}

      {/* HERO */}
      <section className="hero">
        {[slide1, slide2, slide3].map((img, i) => (
          <div key={i} className={`hero-slide ${slide === i ? "show" : ""}`} style={{ backgroundImage: `url(${img})` }}>
            <div className="hero-overlay">
              <h1 className="hero-title">{t.heroTitle?.[i] || "Global Certification"}</h1>
              <p className="hero-subtitle">{t.heroSubtitle}</p>
              <Link to="/contact-us" className="hero-btn">{t.heroBtn}</Link>
            </div>
          </div>
        ))}
        <button className="hero-prev" onClick={() => setSlide((s) => (s - 1 + 3) % 3)}>Previous</button>
        <button className="hero-next" onClick={() => setSlide((s) => (s + 1) % 3)}>Next</button>
      </section>

      {/* WHY CHOOSE */}
      <section className="why-choose">
        <h2 className="section-title">{t.whyTitle}</h2>
        <p className="section-desc">{t.whyDesc}</p>
        <div className="why-grid">
          <div className="why-item">
            <div className="why-icon">World</div>
            <h3>{t.industryKnowledge}</h3>
            <p>{t.industryKnowledgeDesc}</p>
          </div>
          <div className="why-item">
            <div className="why-icon">Search</div>
            <h3>{t.qualifiedAuditors}</h3>
            <p>{t.qualifiedAuditorsDesc}</p>
          </div>
          <div className="why-center">
            <div className="exp-circle">
              <span className="exp-num">08</span>
              <span className="exp-txt">{t.yearsExp}</span>
            </div>
            <div className="exp-list">
              {t.expList.map((item, i) => <div key={i}>{item}</div>)}
            </div>
          </div>
        </div>
      </section>

      {/* INDUSTRIES */}
      <section className="industries">
        <h2 className="section-title">{t.industriesTitle}</h2>
        <div className="ind-grid">
          {t.industries.map((name, i) => {
            const Icon = [Zap, Truck, Building, Car, Landmark, GraduationCap, Train, Stethoscope, Hotel][i];
            return (
              <div key={name} className="ind-card">
                <div className="ind-icon"><Icon size={32} /></div>
                <p>{name}</p>
              </div>
            );
          })}
        </div>
      </section>

      {/* CONSULTING */}
      <section className="consult-cards">
        {t.consulting.map((card, i) => (
          <div key={i} className="c-card">
            <div className="c-icon"></div>
            <h3>{card.title}</h3>
            <p>{card.desc}</p>
            <Link to="/about-us" className="c-link">{t.readMore}</Link>
          </div>
        ))}
      </section>

      {/* STANDARDS */}
      <section className="standards">
        <h2 className="section-title">{t.standardsTitle}</h2>
        <div className="standards-text" dangerouslySetInnerHTML={{ __html: t.standardsText }} />
        <div className="standards-list" dangerouslySetInnerHTML={{ __html: t.standardsList }} />
        <div className="standards-auditors">{t.auditorsText}</div>

        <Link to="/about-us" className="standards-btn">{t.moreAboutCompany}</Link>

        <div className="standards-bottom-pro single-badge">
          <div className="trust-badge">
            <div className="badge-icon">Checkmark</div>
            <div className="badge-text">
              <strong>{t.trustedClients}</strong>
            </div>
          </div>
        </div>
      </section>

      {/* VISION MISSION */}
      <section className="vision-mission-enhanced">
        <div className="vm-card vm-mission">
          <div className="vm-icon">🎯</div>
          <h3>{t.ourMission}</h3>
          <p>{t.missionText}</p>
        </div>
        <div className="vm-card vm-vision">
          <div className="vm-icon">🏆 </div>
          <h3>{t.ourVision}</h3>
          <p>{t.visionText}</p>
        </div>
      </section>

      {/* CONTACT */}
      <section className="contact-card-section">
        <div className="contact-card">
          <h2>{t.contactUs}</h2>
          <p className="cc-name">{t.globalCert}</p>
          <p className="cc-addr">{t.address}</p>
          <p className="cc-contact" dangerouslySetInnerHTML={{ __html: t.phoneEmail }} />
          <Link to="/contact-us" className="cc-btn">{t.appointment}</Link>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="footer">
        <div className="footer-grid">
          <div className="footer-col">
            <h4>{t.aboutCompany}</h4>
            <p>{t.globalCert}<br />{t.address}</p>
          </div>
          <div className="footer-col">
            <h4>{t.usefulLinks}</h4>
            <Link to="/about-us" className="f-link">About Us</Link>
            <Link to="/about-us" className="f-link">Company Profile</Link>
            <Link to="/vision-mission" className="f-link">Vision Mission</Link>
          </div>
          <div className="footer-col">
            <h4>{t.othersLinks}</h4>
            {t.footerLinks.map((link, i) => (
              <Link key={i} to={link.path} className="f-link">{link.name}</Link>
            ))}
          </div>
        </div>
        <p className="copyright">{t.copyright}</p>
      </footer>

      {/* WHATSAPP */}
      <a href="https://wa.me/919975977462" target="_blank" rel="noopener noreferrer" className="whatsapp-fixed">
        <img src={whatsapp} alt="WhatsApp" />
      </a>
    </div>
  );
};

export default Home;